import React from "react";
import Select from "react-select";

const normaliseSearchValue = (value) =>
  String(value || "")
    .normalize("NFKD")
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim();

const containsFilter = (candidate, rawInput) => {
  const input = normaliseSearchValue(rawInput);
  if (!input) return true;
  const option = candidate?.data || {};
  const searchableText = option.searchText || option.label || candidate?.label || "";
  return normaliseSearchValue(searchableText).includes(input);
};

const ReactSelect = ({
  options = [],
  handleSelectedOption,
  placeholder,
  isClearable,
  value,
  isMulti,
  isDisabled = false,
  filterOption = containsFilter,
  noOptionsMessage,
  menuPlacement = "auto",
}) => {
  const menuPortalTarget =
    typeof document !== "undefined" ? document.body : undefined;

  const customStyles = {
    container: (base) => ({
      ...base,
      width: "100%",
      minWidth: 0,
    }),
    control: (base, state) => ({
      ...base,
      minHeight: 44,
      borderColor: state.isFocused ? "rgba(24, 165, 101, 0.75)" : "#cedbd4",
      borderRadius: 11,
      backgroundColor: state.isDisabled ? "#f3f6f4" : "#ffffff",
      boxShadow: state.isFocused
        ? "0 0 0 4px rgba(24, 165, 101, 0.11)"
        : "0 1px 0 rgba(8, 52, 34, 0.02)",
      cursor: state.isDisabled ? "not-allowed" : "text",
      transition: "border-color 180ms ease, box-shadow 180ms ease",
      ":hover": {
        borderColor: state.isFocused
          ? "rgba(24, 165, 101, 0.75)"
          : "#b8cec2",
      },
    }),
    valueContainer: (base) => ({
      ...base,
      minWidth: 0,
      padding: isMulti ? "4px 11px" : "0 11px",
      flexWrap: isMulti ? "wrap" : "nowrap",
      overflow: "hidden",
    }),
    input: (base) => ({
      ...base,
      minWidth: 2,
      margin: 0,
      padding: 0,
      color: "#10231b",
    }),
    placeholder: (base) => ({
      ...base,
      maxWidth: "100%",
      margin: 0,
      overflow: "hidden",
      color: "#83928b",
      fontSize: 13,
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    }),
    singleValue: (base) => ({
      ...base,
      maxWidth: "100%",
      margin: 0,
      overflow: "hidden",
      color: "#10231b",
      fontSize: 13,
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: 42,
      flexShrink: 0,
    }),
    indicatorSeparator: () => ({ display: "none" }),
    dropdownIndicator: (base, state) => ({
      ...base,
      width: 34,
      height: 42,
      padding: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: state.isFocused ? "#087645" : "#6f8077",
    }),
    clearIndicator: (base) => ({
      ...base,
      width: 34,
      height: 42,
      padding: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#6f8077",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
      marginTop: 6,
      overflow: "hidden",
      border: "1px solid #dfe8e3",
      borderRadius: 12,
      backgroundColor: "#ffffff",
      boxShadow: "0 18px 50px rgba(13, 44, 32, 0.11)",
    }),
    menuList: (base) => ({ ...base, maxHeight: 260, padding: 6 }),
    option: (base, state) => ({
      ...base,
      marginBottom: 2,
      padding: "9px 10px",
      borderRadius: 8,
      color: state.isSelected ? "#ffffff" : "#53645d",
      backgroundColor: state.isSelected
        ? "#18a565"
        : state.isFocused
          ? "#edf8f2"
          : "#ffffff",
      fontSize: 12,
      lineHeight: 1.35,
      cursor: "pointer",
      ":active": {
        backgroundColor: state.isSelected ? "#18a565" : "#e5f5ed",
      },
    }),
    multiValue: (base) => ({
      ...base,
      margin: 2,
      borderRadius: 7,
      backgroundColor: "#eaf7f0",
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: "#075137",
      fontSize: 11,
      fontWeight: 650,
    }),
  };

  return (
    <div className="gm-react-select">
      <Select
        className="gm-select"
        classNamePrefix="gm-select"
        isSearchable
        value={value}
        styles={customStyles}
        options={options}
        placeholder={placeholder}
        isClearable={isClearable}
        onChange={handleSelectedOption}
        isMulti={isMulti}
        isDisabled={isDisabled}
        filterOption={filterOption}
        noOptionsMessage={noOptionsMessage || (() => "No matching options")}
        menuPortalTarget={menuPortalTarget}
        menuPosition="fixed"
        menuPlacement={menuPlacement}
      />
    </div>
  );
};

export default ReactSelect;

// import React from "react";
// import Select from "react-select";

// const ReactSelect = ({
//   options,
//   handleSelectedOption,
//   placeholder,
//   isClearable,
//   value,
//   isMulti,
// }) => {
//   const menuPortalTarget =
//     typeof document !== "undefined" ? document.body : undefined;

//   const customStyles = {
//     container: (base) => ({
//       ...base,
//       width: "100%",
//       minWidth: 0,
//     }),
//     control: (base, state) => ({
//       ...base,
//       minHeight: 44,
//       borderColor: state.isFocused ? "rgba(24, 165, 101, 0.75)" : "#cedbd4",
//       borderRadius: 11,
//       backgroundColor: "#ffffff",
//       boxShadow: state.isFocused
//         ? "0 0 0 4px rgba(24, 165, 101, 0.11)"
//         : "0 1px 0 rgba(8, 52, 34, 0.02)",
//       cursor: "text",
//       transition: "border-color 180ms ease, box-shadow 180ms ease",
//       ":hover": {
//         borderColor: state.isFocused
//           ? "rgba(24, 165, 101, 0.75)"
//           : "#b8cec2",
//       },
//     }),
//     valueContainer: (base) => ({
//       ...base,
//       minWidth: 0,
//       padding: isMulti ? "4px 11px" : "0 11px",
//       flexWrap: isMulti ? "wrap" : "nowrap",
//       overflow: "hidden",
//     }),
//     input: (base) => ({
//       ...base,
//       minWidth: 2,
//       margin: 0,
//       padding: 0,
//       color: "#10231b",
//     }),
//     placeholder: (base) => ({
//       ...base,
//       maxWidth: "100%",
//       margin: 0,
//       overflow: "hidden",
//       color: "#83928b",
//       fontSize: 13,
//       textOverflow: "ellipsis",
//       whiteSpace: "nowrap",
//     }),
//     singleValue: (base) => ({
//       ...base,
//       maxWidth: "100%",
//       margin: 0,
//       overflow: "hidden",
//       color: "#10231b",
//       fontSize: 13,
//       textOverflow: "ellipsis",
//       whiteSpace: "nowrap",
//     }),
//     indicatorsContainer: (base) => ({
//       ...base,
//       height: 42,
//       flexShrink: 0,
//     }),
//     indicatorSeparator: () => ({
//       display: "none",
//     }),
//     dropdownIndicator: (base, state) => ({
//       ...base,
//       width: 34,
//       height: 42,
//       padding: 0,
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       color: state.isFocused ? "#087645" : "#6f8077",
//     }),
//     clearIndicator: (base) => ({
//       ...base,
//       width: 34,
//       height: 42,
//       padding: 0,
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       color: "#6f8077",
//     }),
//     menuPortal: (base) => ({
//       ...base,
//       zIndex: 9999,
//     }),
//     menu: (base) => ({
//       ...base,
//       zIndex: 9999,
//       marginTop: 6,
//       overflow: "hidden",
//       border: "1px solid #dfe8e3",
//       borderRadius: 12,
//       backgroundColor: "#ffffff",
//       boxShadow: "0 18px 50px rgba(13, 44, 32, 0.11)",
//     }),
//     menuList: (base) => ({
//       ...base,
//       maxHeight: 260,
//       padding: 6,
//     }),
//     option: (base, state) => ({
//       ...base,
//       marginBottom: 2,
//       padding: "9px 10px",
//       borderRadius: 8,
//       color: state.isSelected ? "#ffffff" : "#53645d",
//       backgroundColor: state.isSelected
//         ? "#18a565"
//         : state.isFocused
//           ? "#edf8f2"
//           : "#ffffff",
//       fontSize: 12,
//       lineHeight: 1.35,
//       cursor: "pointer",
//       ":active": {
//         backgroundColor: state.isSelected ? "#18a565" : "#e5f5ed",
//       },
//     }),
//     multiValue: (base) => ({
//       ...base,
//       margin: 2,
//       borderRadius: 7,
//       backgroundColor: "#eaf7f0",
//     }),
//     multiValueLabel: (base) => ({
//       ...base,
//       color: "#075137",
//       fontSize: 11,
//       fontWeight: 650,
//     }),
//   };

//   return (
//     <div className="gm-react-select">
//       <Select
//         className="gm-select"
//         classNamePrefix="gm-select"
//         isSearchable
//         value={value}
//         styles={customStyles}
//         options={options}
//         placeholder={placeholder}
//         isClearable={isClearable}
//         onChange={handleSelectedOption}
//         isMulti={isMulti}
//         menuPortalTarget={menuPortalTarget}
//         menuPosition="fixed"
//       />
//     </div>
//   );
// };

// export default ReactSelect;

// // import React from 'react';
// // import Select from "react-select"

// // const ReactSelect = ({options,handleSelectedOption,placeholder,isClearable,value,isMulti}) => {

// //   const customStyle = {
// //     option: (provided, state) => ({
// //       ...provided,
// //       padding:"5px",
// //       margin:"5px",
// //       backgroundColor: state.isSelected ? '#30A46C' : 'white',
// //       color: state.isSelected ? 'white' : 'black',
// //       ':hover': {
// //         backgroundColor: '#30A46C',
// //         color:"white",
        
// //       },
// //     }),
// //     control:(provided,state)=>({
// //       ...provided,
// //       // height:"32px"
// //       // minHeight:"32px",
// //       // height:"auto",
// //       // overflow:"visible",
// //       // marginBottom:"10px"
// //     }),
// //     input: (provided, state) => ({
// //       ...provided,
// //       margin: '0px',
// //       padding:"0px"
// //     })
// //   };
  
// //   return (
// //     <div>
// //         <Select 
// //         isSearchable
// //         value={value}
// //         styles={customStyle}
// //         options={options}
// //         // placeholder={"checck"}
// //         placeholder={placeholder}
// //         isClearable={isClearable}
// //         onChange={handleSelectedOption}
// //         isMulti={isMulti}
        
// //         />
// //     </div>
// //   )
// // }

// // export default ReactSelect